import React from 'react';
import PropTypes from 'prop-types';
import ParameterUnit from './ParameterUnit';
import SongStore from '../stores/SongStore';

export default class BottomView extends React.Component {
	static propTypes = {
		name: PropTypes.string
	};

	static contextTypes = {
		executeAction: PropTypes.func.isRequired,
		getStore: PropTypes.func.isRequired
	};

	constructor(props, context) {
		super(props, context);

		var store = context.getStore(SongStore);

		this.state = {
			channel: store.getSelectedChannel()
		};

		store.on("BOTTOMVIEW_UPDATE", () => {
			this.setState({
				channel: store.getSelectedChannel()
			});
		});
	}

	render() {

		var units = [];
		var key = 0;

		var count = this.state.channel.effects.length;

		units.push(<ParameterUnit
			parameters={this.state.channel.instrument.getParameters()}
			name={this.state.channel.instrument.name} key={key} type="instrument" position={key} count={count}/>);

		for(var i = 0; i < count; i++) {
			units.push(<ParameterUnit
				parameters={this.state.channel.effects[i].getParameters()}
				name={this.state.channel.effects[i].name} key={++key} type="effect" position={key} count={count} number={this.state.channel.effects[i].getNumber()}/>);
		}

		return (
			<div className="BottomView">
				{units}
			</div>
		);
	}
}
